module.exports = __webpack_public_path__ + "static/media/PlugInHybrid.044b648a.svg";